export default __webpack_public_path__ + "static/media/icon-checkmark.b4761351.svg";